function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.1436 2.62148C10.3381 2.62148 10.5 2.78298 10.5 2.98848V3.17848C10.5 3.37898 10.3381 3.54547 10.1436 3.54547H1.85693C1.66193 3.54547 1.5 3.37898 1.5 3.17848V2.98848C1.5 2.78298 1.66193 2.62148 1.85693 2.62148H3.31478C3.61092 2.62148 3.86865 2.41099 3.93527 2.11399L4.01162 1.77299C4.13027 1.3085 4.52075 1 4.96764 1H7.03236C7.47439 1 7.86925 1.3085 7.98352 1.74849L8.06522 2.11349C8.13135 2.41099 8.38907 2.62148 8.6857 2.62148H10.1436ZM9.40291 9.56701C9.55512 8.14853 9.8216 4.77856 9.8216 4.74456C9.83132 4.64156 9.79777 4.54406 9.73115 4.46557C9.65967 4.39207 9.56922 4.34857 9.46953 4.34857H2.53426C2.43409 4.34857 2.33878 4.39207 2.27264 4.46557C2.20554 4.54406 2.17247 4.64156 2.17733 4.74456C2.17823 4.75081 2.18779 4.86951 2.20378 5.06797C2.27479 5.94959 2.47258 8.40508 2.60039 9.56701C2.69084 10.423 3.25249 10.961 4.06603 10.9805C4.69381 10.995 5.34056 11 6.0019 11C6.62482 11 7.25746 10.995 7.9047 10.9805C8.74644 10.966 9.3076 10.4375 9.40291 9.56701Z",
  fill: "#C7C9CC"
});
function SvgDeleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.4c78921e.svg";
export { ForwardRef as ReactComponent };